/* eslint-disable react-hooks/exhaustive-deps */
import React, { useLayoutEffect, useState } from "react";
import { displayMessage, postAPI, getAPI } from "../../utils/common";
import { ERROR_MSG_TYPE, SUCCESS_MESSAGE } from "../../constants/messages";
import { PlusOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import LayoutHeader from "../inc/LayoutHeader";
import LayoutFooter from "../inc/LayoutFooter";
import {
  Space,
  Button,
  Card,
  Popconfirm,
  Layout,
  Table,
  Input,
  Tooltip,
  Switch,
} from "antd";
import { ALL_CAREER, DELETE_CAREER, EDIT_CAREER } from "../../constants/api";

function CareerTable() {
  const { Content } = Layout;
  const [state, setState] = useState([]);
  const [filteredState, setFilteredState] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchText, setSearchText] = useState("");
  const navigate = useNavigate();

  useLayoutEffect(() => {
    getList();
  }, []);

  const getList = () => {
    setLoading(true);
    const successFn = function (data) {
      if (data.status === true) {
        setState([]);
        setFilteredState([]);
        const formattedData = data["data"].map((row, index) => ({
          key: index,
          id: index + 1,
          title: row.title,
          location: row.location,
          type: row.type,
          status: (
            <Space>
              <Tooltip
                title={`Make them ${row.status === 1 ? "In-Active" : "Active"}`}
              >
                <Switch
                  loading={loading}
                  disabled={loading}
                  defaultChecked={row.status === 1}
                  onChange={(e) => updateStatus(row, e)}
                />
              </Tooltip>
            </Space>
          ),
          action: (
            <Space>
              <Button
                onClick={() => {
                  navigate("/career/edit/" + row.id);
                }}
                block
              >
                Edit
              </Button>
              <Popconfirm
                title="Delete the task"
                description="Are you sure to delete this task?"
                onConfirm={() => deleteData(row.id)}
                okText="Yes"
                cancelText="No"
              >
                <Button danger>Delete</Button>
              </Popconfirm>
            </Space>
          ),
        }));
        setState(formattedData);
        setFilteredState(formattedData); // Set filtered state initially to all items
        setLoading(false);
      } else {
        setState([]);
        setLoading(false);
      }
    };
    const errorFn = function () {
      setState([]);
      setLoading(false);
    };
    getAPI(ALL_CAREER, successFn, errorFn, {});
  };

  const updateStatus = (id, e) => {
    setLoading(true);
    const jsonData = {
      ...id,
      status: e === true ? 1 : 0,
    };

    const successFn = function (data) {
      if (data.status === true) {
        setLoading(false);
        displayMessage(SUCCESS_MESSAGE, data.message);
      } else {
        setLoading(false);
        displayMessage(ERROR_MSG_TYPE, data.message);
      }
      getList();
    };
    const errorFn = function () {
      setLoading(false);
      displayMessage(ERROR_MSG_TYPE, "Unable to Update Data");
    };
    postAPI(EDIT_CAREER, jsonData, successFn, errorFn);
  };
  const deleteData = (values) => {
    setLoading(true);
    let data = {
      id: values,
    };
    const successFn = function (data) {
      if (data.status === true) {
        setLoading(false);
        getList();
        displayMessage(SUCCESS_MESSAGE, data.message);
      } else {
        setLoading(false);
        displayMessage(ERROR_MSG_TYPE, data.message);
      }
    };
    const errorFn = function () {
      setLoading(false);
      displayMessage(ERROR_MSG_TYPE, "Unable to Delete Data");
    };
    postAPI(DELETE_CAREER, data, successFn, errorFn);
  };

  const handleSearch = (value) => {
    setSearchText(value);
    const filtered = state.filter(
      (row) =>
        row.title.toLowerCase().includes(value.toLowerCase()) ||
        row.location.toLowerCase().includes(value.toLowerCase()) ||
        row.type.toLowerCase().includes(value.toLowerCase())
    );
    setFilteredState(filtered);
  };

  const columns = [
    {
      title: "Sno",
      dataIndex: "id",
    },

    {
      title: "Title",
      dataIndex: "title",
    },
    {
      title: "Type",
      dataIndex: "type",
    },
    {
      title: "Location",
      dataIndex: "location",
    },
    {
      title: "Status Action",
      dataIndex: "status",
    },
    {
      title: "Action",
      dataIndex: "action",
    },
  ];

  return (
    <>
      <Layout>
        <LayoutHeader />
        <Content>
          <Card
            title="Manage Carrer Opnings"
            extra={
              <Space>
                <Input
                  placeholder="Search by Title or Type"
                  value={searchText}
                  onChange={(e) => handleSearch(e.target.value)}
                  style={{ width: 300 }}
                />
                <Button onClick={() => navigate("/career/add")}>
                  Add <PlusOutlined />
                </Button>
              </Space>
            }
            bordered={true}
          >
            <Table
              loading={loading}
              columns={columns}
              dataSource={filteredState}
              pagination={{ pageSize: 10 }}
              scroll={{ x: 240 }}
            />
          </Card>
        </Content>
        <LayoutFooter />
      </Layout>
    </>
  );
}

export default CareerTable;
